export const swapContractAddress = "0x8cBE85637875Ec04CEAE69eC35cbfdFDddD3835E";
export const NFTDAddress = "0xb0bC5ADB8F65E9bf9e5Cd11C979181CBF22341dd";
export const DAIAddress = "0x11fE4B6AE13d2a6055C8D9cF65c55bac32B5d844";
export const USDCAddress = "0x07865c6E87B9F70255377e024ace6630C1Eaa37F";
